<div class="shipment-details-container">
  <form [formGroup]="formGroup">
    <!-- commodityGroup -->
    <div>
      <lib-external-dropdown #commodityDropdown
        [propertyType]="'COMMODITY_GROUP'"
        [isSubmitted]="isSubmitted"
        [formControlData]="formGroup"
        [dropDownName]="'commodityGroup'"
        [labelName]="serviceTypeLabel"
        [fullWidth]="true"
        [showErrors]="true"
        [required]="true"
        (selectedType)="onSelected($event, 'commodityCategory')"
      ></lib-external-dropdown>
    </div>
    <!-- commodityGroup -->
    <div formArrayName="lanes">
      @for (lane of lanes.controls; let i = $index; track $index) {
      <app-create-lane-twisty
        #twistyComponent
        [group]="$any(lane)"
        [indexValue]="i"
        (copyLane)="copyLane(i)"
        (deleteLane)="deleteLane(i)"
        [isSubmitted]="isSubmitted"
        [activeLaneIndex]="activeLaneIndex"
        [isRailSelected] ="isRailSelected"
      >
      </app-create-lane-twisty>
      }
    </div>
    <!-- add lane button -->
    <div>
      <up-button button-style="outlined" (click)="createLane()"
        >Add Lane</up-button
      >
    </div>
    <!-- rail price radio -->
    <div>
      <span>Include rail pricing with our offer?</span><br />
      <div>
        <label>
          <up-radio>
            <input
              type="radio"
              formControlName="includeRailPricing"
              [value]="true"
              (change)="onRadioSelect(true)"
            />
          </up-radio>
          Yes
        </label>
        <label>
          <up-radio>
            <input
              type="radio"
              formControlName="includeRailPricing"
              [value]="false"
              (change)="onRadioSelect(false)"
            />
          </up-radio>
          No
        </label>
      </div>
    </div>
    <div class="inline-row">
      <!-- business group -->
      <div>
        <lib-external-dropdown #businessDropdown
          [propertyType]="'BUSINESS_DURATION'"
          [isSubmitted]="isSubmitted"
          [formControlData]="formGroup"
          [dropDownName]="'businessDuration'"
          [labelName]="businessDurationLabel"
          [fullWidth]="true"
          [showErrors]="true"
          [required]="true"
          (selectedType)="onSelected($event, 'businessDuration')"
        >
        </lib-external-dropdown>
      </div>
      <!-- date field -->
      <div>
        <lib-single-date-picker #datepicker
          [displayDefaultDate]="false"
          [required]="true"
          [isSubmitted]="isSubmitted"
          [disablePastDates]="true"
          [showTillYesterday]="false"
          [placeholder]="'Estimated Start Date'"
          (dateChange)="changedDate($event)"
        ></lib-single-date-picker>
      </div>
    </div>
    <!-- comments -->
    <div>
      <lib-common-comments #commonComments [commentData]="formGroup.get('comments')?.value"
        [textLength]="1000" (commentUpdated)="commentData($event)"></lib-common-comments>
    </div>
    <!-- actions button -->
    <div>
      <up-button button-style="text" (click)="resetAction.emit()">Reset</up-button>
      <up-button button-style="text" (click)="back.emit()">back</up-button>
      <up-button button-style="contained" (click)="submitAction()">Submit</up-button>
    </div>
  </form>
</div>
